"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.Button = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')({
    display: 'block'
});
const Button = exports.Button = (0, _mui.styled)('button')((param)=>{
    let { theme } = param;
    return {
        display: 'block',
        boxSizing: 'border-box',
        width: 'auto',
        minWidth: 200,
        height: 35,
        margin: theme.spacing(6, 'auto', 0),
        overflow: 'hidden',
        transition: 'box-shadow 0.15s, transform 0.15s',
        border: "2px solid ".concat(theme.palette.grey[200]),
        borderRadius: 999,
        background: theme.palette.common.white,
        color: theme.palette.text.primary,
        fontSize: '1.2rem',
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: '3.3rem',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        '&:hover': {
            boxShadow: _mui.SHADOW_LEVEL3
        },
        '&:hover, &:active, &:focus': {
            outline: 'none'
        }
    };
});
